// @flow

import React from "react";
import { localize } from "redux-i18n";

import { Text, View, Checkbox } from "@components";
import type { SpecialContactType } from "@modules/shared/reducer/special-contact-types/types";
import type { Alert, AlertSpecialContactType } from "@modules/service/reducer/alerts/types";
import { FULL_NOTIFICATION_CONTACTS } from "@modules/service/constants";

type RecipientOption = $Exact<{ id: number, label: string }>;

type Props = $Exact<{
  data: Alert,
  specialContactTypes: Array<SpecialContactType>,
  ...PropsFromLocalize,
}>;

export class AlertRecipientsView extends React.Component<Props> {
  get data(): Array<AlertSpecialContactType> {
    const notificationContactSelected = this.props.data.details.notifyEmployeeContacts;
    let specialContactTypes = this.props.data.specialContactTypes || [];

    if (specialContactTypes && notificationContactSelected) {
      specialContactTypes = [
        ...[
          {
            id: 0,
            name: this.props.t(FULL_NOTIFICATION_CONTACTS),
          },
        ],
        ...specialContactTypes,
      ];
    }

    return specialContactTypes;
  }

  get options(): Array<RecipientOption> {
    return [
      ...[
        {
          id: 0,
          label: this.props.t(FULL_NOTIFICATION_CONTACTS),
        },
      ],
      ...this.props.specialContactTypes.map(r => ({ id: r.id, label: r.name })),
    ];
  }

  render() {
    return (
      <View gap={3} className="gs-container">
        <View>
          <Text type="h6" text={this.props.t("DEFAULT")} />
        </View>
        <View display="grid" gap={2} gridTemplateColumns={3}>
          {this.options &&
            this.options.map(o => (
              <Checkbox
                key={o.label}
                id={o.label}
                label={o.label}
                checked={!!this.data.find(d => d.id === o.id)}
                disabled={true}
              />
            ))}
        </View>
      </View>
    );
  }
}

export default localize()(AlertRecipientsView);
